import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getToken } from '../APIServices'
import {
  NetworkRequestError,
  RequestErrorResponse,
  get,
  handleClientError,
  post,
  remove
} from '../lib'
import { number } from 'joi'

export type NotesResponseType = {
  notes: string | null
  vehicle: string | null
  neoRestful: string | null
  error: null | string
}

export type ExportFormatsResponseTypes = {
  enabled: boolean
  exporterValue: number | string
  extension: string
  id: number | string
  name: string
  version: number | string
  _href: string
}
export type ExportRequestPayload = {
  selectedIds: Record<string | number, string[]>
  format: number | string
  forceRate: number | string
}

type ExportSuccessResponse = {
  device: string
  jobs: number
}

type ExportApiResponse = {
  error: NetworkRequestError | null
  success: ExportSuccessResponse[]
}

type DownloadApiRequest = {
  selectedIds: number[] | string[]
  flatten: boolean
  timezoneOffset: string
}

interface User {
  id: number
}
interface userDownloadApiResponse {
  dateCreated: string
  downloaded: boolean
  expirationDate: string
  id: number | string
  isUserFile: boolean
  name: string
  path: string
  size: number
  token: string | null
  tokenExpiration: string | null
}

export interface DownloadApiResponse extends userDownloadApiResponse {
  errors?: any
  user: User
}

export interface ScriptsResponse {
  id: number
  _href: string
  downloadFile: DownloadFile
  dateCreated: Date | null
  collections: Collection[]
  coremini32: boolean
  coreminiSize: number
  version: number
  coremini16: boolean
  vspyVersion: string | number | null
  vsdbName: string
}

export interface Collection {
  id: number
  name: string
}

export interface DownloadFile {
  id: string
  name: string
  size: string
}

export interface DownloadFilesResponse {
  id: number
  _href: string
  files: any[]
  dateCreated: Date
  size: number
  uniqueId: null
  md5: string
  version: number
  name: string
  user: fileUser
  downloads: Download[]
  description: string
}

export interface Download {
  id: number
  name: string
  downloadFileId: number
}

export interface fileUser {
  id: number
  name: string
}

export interface DownloaderResponse {
  token: string
  expires: string
}
export interface DownloaderPayload {
  token: string
  expires: string
  fileName: string
}

export const dataApi = createApi({
  reducerPath: 'dataApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v1/',
    prepareHeaders: (headers) => {
      const token = getToken()
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    }
  }),
  endpoints: (builder) => ({
    fetchNotes: builder.query<NotesResponseType, string>({
      query: (uploadId: string) => `data/notes?id=${uploadId}`,
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
        } catch (error) {
          // if (error.status === 401) {
          //   window.location.href = '/ui/#!/'
          // }
        }
      }
    }),
    uploadExportFormats: builder.query<ExportFormatsResponseTypes[], string>({
      query: (sort: string) => `uploadExportFormats?sort=${sort}`,
      transformResponse: (response: ExportFormatsResponseTypes[]) => {
        return response
      }
    }),
    exportMutation: builder.mutation<ExportApiResponse, ExportRequestPayload>({
      query: (payload) => ({
        url: 'data/export',
        method: 'POST',
        body: payload
      })
    }),
    download: builder.mutation<DownloadApiResponse, DownloadApiRequest>({
      query: (payload) => ({
        url: 'data/download',
        method: 'POST',
        body: payload
      })
    }),
    userDownloads: builder.query<userDownloadApiResponse[], string | number>({
      query: (id: string | number) => `user-downloads?id=${id}`
    }),
    deleteFile: builder.mutation({
      query: (fileId) => ({
        url: `uploadFileVersions/${fileId}`,
        method: 'DELETE'
      })
    }),
    //facing 404 error against getQickView API
    getQuickView: builder.query({
      query: (uploadFileVersionId) =>
        `quickView?uploadFileVersionId=${uploadFileVersionId}`
    })
    // getDownloadFiles: builder.query({
    //   query: (id) => `/downloadFiles/${id}`,
    //   async onQueryStarted(id, { dispatch, queryFulfilled }) {
    //     try {
    //       await queryFulfilled
    //     } catch (error) {
    //       // if (error.status === 401) {
    //       //   window.location.href = '/ui/#!/'
    //       // }
    //     }
    //   }
    // }),
    // getScripts: builder.query({
    //   query: (id) => `/scripts/${id}`,
    //   async onQueryStarted(id, { dispatch, queryFulfilled }) {
    //     try {
    //       await queryFulfilled
    //     } catch (error) {
    //       // if (error.status === 401) {
    //       //   window.location.href = '/ui/#!/'
    //       // }
    //     }
    //   }
    // }),
    // downloadVsdb: builder.query({
    //   query: ({ downloadId, scriptId }) =>
    //     `/downloader/request?type=vsdb&id=${downloadId}&scriptId=${scriptId}`,
    //   async onQueryStarted(
    //     args: { downloadId: number; scriptId: number },
    //     { dispatch, queryFulfilled }
    //   ) {
    //     try {
    //       const { data } = await queryFulfilled
    //       const downloadToken = data.token
    //       dispatch(dataApi.endpoints.retrieveDownload.initiate(downloadToken))
    //     } catch (error) {
    //       // if (error.status === 401) {
    //       //   window.location.href = '/ui/#!/'
    //       // }
    //     }
    //   }
    // }),
    // downloadVs3zip: builder.query({
    //   query: (downloadId) =>
    //     `/downloader/request?type=download&id=${downloadId}`,
    //   async onQueryStarted(id, { dispatch, queryFulfilled }) {
    //     try {
    //       const { data } = await queryFulfilled
    //       const downloadToken = data.token
    //       dispatch(dataApi.endpoints.retrieveDownload.initiate(downloadToken))
    //     } catch (error) {
    //       // if (error?.status === 401) {
    //       //   window.location.href = '/ui/#!/'
    //       // }
    //     }
    //   }
    // }),
    // retrieveDownload: builder.query<DownloadFilesResponse, any>({
    //   query: (downloadToken) => `/downloader/retrieve?token=${downloadToken}`,
    //   async onQueryStarted(downloadToken, { dispatch, queryFulfilled }) {
    //     try {
    //       const result = await queryFulfilled
    //       const fileName = 'script'
    //       const link = document.createElement('a')
    //       const currentDate = new Date().valueOf()
    //       link.setAttribute('download', `${fileName}${currentDate}`)
    //       link.href = `${window.location.hostname}/api/v1/downloader/retrieve?token=${downloadToken}` // Make sure your API returns a valid URL
    //       document.body.appendChild(link)
    //       link.click()
    //       link.remove()
    //     } catch (error) {
    //       // if (error.status === 401) {
    //       //   window.location.href = '/ui/#!/'
    //       // }
    //     }
    //   }
    // })
  })
})

export const {
  useLazyFetchNotesQuery,
  useLazyUploadExportFormatsQuery,
  useExportMutationMutation,
  useUploadExportFormatsQuery,
  useDownloadMutation,
  useUserDownloadsQuery,
  useLazyUserDownloadsQuery,
  useDeleteFileMutation,
  useGetQuickViewQuery
  // useLazyGetDownloadFilesQuery,
  // useGetScriptsQuery,
  // useLazyDownloadVs3zipQuery,
  // useLazyDownloadVsdbQuery,
  // useLazyRetrieveDownloadQuery
} = dataApi

export const getExtractionNotes = async (
  uploadId: string
): Promise<NotesResponseType> => {
  try {
    const res = await get<NotesResponseType>({
      path: `/api/v1/data/notes?id=${uploadId}`
    })
    return res
  } catch (e: any) {
    throw handleClientError(e)
  }
}

export const getDownloadFiles = async (
  id: string
): Promise<DownloadFilesResponse> => {
  try {
    const res = await get<DownloadFilesResponse>({
      path: `/api/v1/downloadFiles/${id}`
    })
    return res
  } catch (e: any) {
    throw handleClientError(e)
  }
}

export const getScripts = async (id: string): Promise<ScriptsResponse> => {
  try {
    const res = await get<ScriptsResponse>({
      path: `/api/v1/scripts/${id}`
    })
    return res
  } catch (e: any) {
    throw handleClientError(e)
  }
}

export const downloadVsdb = async (
  downloadId: string,
  scriptId: string,
  fileName: string
): Promise<DownloaderPayload> => {
  const token = getToken()
  const res = await fetch(
    `/api/v1/downloader/request?type=vsdb&id=${downloadId}&scriptId=${scriptId}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      }
    }
  )

  return {
    ...res.json(),
    fileName: fileName
  }
}

export const downloadVs3zip = async (
  downloadId: string,
  fileName: string
): Promise<DownloaderPayload> => {
  const token = getToken()
  const res = await fetch(
    `/api/v1/downloader/request?type=download&id=${downloadId}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      }
    }
  )

  return {
    ...res.json(),
    fileName: fileName
  }
}

export const retrieveDownload = async (downloadToken, fileName) => {
  const token = getToken()
  const res = await fetch(
    `/api/v1/downloader/retrieve?token=${downloadToken}`,
    {
      method: 'GET',
      headers: {
        Accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7'
      }
    }
  )
  const link = document.createElement('a')
  const currentDate = new Date().valueOf()
  link.setAttribute('download', `${fileName}-${currentDate}`)
  link.href = `${window.location.hostname}/api/v1/downloader/retrieve?token=${downloadToken}`
  document.body.appendChild(link)
  link.click()
  link.remove()
}

/**
 * Below is new code which is expected to be kept
 *
 */

export interface DataSearchRequest {
  startDate: string | null
  endDate: string | null
  fleetId: string[]
  vehicleId: string[]
  extensions: string[]
  names: string[]
  sort: string //should be enum
  order: 'desc' | 'asc'
  offset: number
  max: number
  onlyGroups: boolean
  isLocal?: boolean
}
export interface DataSearchResponseItem {
  id: number
  uploadId: number
  groupId: null | string
  displayName: string
  name: string
  startDate: string
  endDate: string
  collection: null | string
  device: {
    id: number
    name: string
  }
  vehicle: {
    displayName: string
    id: number
    name: string
  }
  fleet: {
    id: number
    name: string
  }
  script: {
    id: number
    name: string
  } | null
  extractionNotesTxt: boolean
  dataSpy: string[]
  versions: DataSearchResponseItemVersion[]
  viewable: string[]
}

export interface DataSearchResponseItemVersion {
  id: number
  extension: string
  archived: string | null
  checkedOut: string | null
  size: number
}

export type DataSearchResponse = DataSearchResponseItem[]
export type FullDataSearchResponse = {
  paging: {
    max: number
    offset: number
    total: number
  }
  data: DataSearchResponse
}
type _ClientDataSearchResponse = {
  data: DataSearchResponse
  headers: Headers
}

export interface LocationSearchRequest {
  vehicleId: number
  startDate: string // format: 'YYYY/MM/DD HH:mm:ss' in UTC
  endDate: string // format: 'YYYY/MM/DD HH:mm:ss' in UTC
  sort: string // e.g., "gpsTimestamp"
  order: 'asc' | 'desc'
  offset: number
  max: number
}

export interface LocationSearchResult {
  id: number
  accuracy: number
  device: number
  gpsTimestamp: string // ISO timestamp
  latitude: number
  longitude: number
  speedMps: number
  speedKph: number
  speedMph: number
  vehicle: number
}

export type LocationSearchResponse = { data: LocationSearchResult[] }

const _getHeaderNumber = (val: null | string): number | undefined => {
  if (val === null) return undefined
  return parseInt(`${val}`) || undefined
}

export const searchData = async (
  req: DataSearchRequest
): Promise<FullDataSearchResponse> => {
  try {
    const res = await post<DataSearchRequest, _ClientDataSearchResponse>({
      path: '/api/v1/data/search',
      body: req,
      includeHeaders: true
    })

    return {
      data: res.data,
      paging: {
        max: _getHeaderNumber(res.headers.get('x-wivi-max')) || 0,
        offset: _getHeaderNumber(res.headers.get('x-wivi-offset')) || 0,
        total: _getHeaderNumber(res.headers.get('x-wivi-total')) || 0
      }
    }
  } catch (e: unknown) {
    //This is horid, need to fix
    throw handleClientError(e as NetworkRequestError)
  }
}

export const searchLocationData = async (req: LocationSearchRequest) => {
  try {
    return await post<LocationSearchRequest, LocationSearchResponse>({
      path: '/api/v1/locations/search',
      body: req,
      includeHeaders: true
    })
  } catch (e: unknown) {
    throw handleClientError(e as NetworkRequestError)
  }
}

export const deleteFile = async (fileId: number) => {
  try {
    const res = await remove({
      path: `/api/v1/uploadFileVersions`,
      id: fileId
    })
    return res
  } catch (e: any) {
    throw handleClientError(e)
  }
}

export type DownloadResponse = {
  id: number
  isUserFile: boolean
  dateCreated: string
  size: number
  path: string
  name: string
  user?: { id: number }
  downloaded: boolean
  expirationDate: string
}

export const createDataDownload = async (objecter: {
  selectedIds: string[]
  flattener: boolean
  timezoneOffset: string | undefined
}): Promise<DownloadResponse> => {
  return post({
    path: `/api/v1/data/download`,
    body: {
      selectedIds: objecter.selectedIds,
      flatten: objecter.flattener,
      timezoneOffset: objecter.timezoneOffset
    }
  })
}

export const getUserDownloadStatus = async (
  id: number
): Promise<DownloadResponse> => {
  return get({
    path: `/api/v1/userDownloads/${id}`
  })
}

type downloadToken = {
  token: string
  expires: string
}

export const getDownloadFileToken = async (
  id: number
): Promise<downloadToken> => {
  return get({
    path: `/api/v1/downloader/request?type=user&id=${id}`
  })
}

export const downloadFile = async (d: downloadToken) => {
  return get({
    path: `/api/v1/downloader/retrieve?token=${d.token}`
  })
}

export type ExportFormatsResponseType = {
  id: number
  _href: string
  exporterValue: number
  name: string
  extension: string
  version: number
  enabled: boolean
}

export const getUploadExportFormats = async (sort: string) => {
  return get<ExportFormatsResponseType[]>({
    path: `/api/v1/uploadExportFormats?sort=${sort}`
  })
}

export type ExportRequest = {
  selectedIds: Record<number, number[]>
  format: number | string
  forceRate: number | string
}

type ExportSuccess = {
  device: string
  jobs: number
}

type ExportResponse = {
  error: string[]
  success: ExportSuccess[]
}

export const exportVSB = async (req: ExportRequest) => {
  return post<ExportRequest, ExportResponse>({
    path: `/api/v1/data/export`,
    body: req
  })
}

type DownloadNotificationResponse = {
  id: number
  _href: string
  what: string
  whatId: number
  version: number
  notificationEnabled: boolean
  triggeredCount: number
  emailEnabled: boolean
  user: {
    id: number
    name: string
  }
  type: string
  frequency: string
}

type DownloadNotificationRequest = {
  emailEnabled: boolean
  what: string
  whatId: number
  triggerCount: number
  user: number
  type: string
  frequency: string
}

export const createDownloadNotification = async (req: {
  userId: number
  userDownloadId: number
}) => {
  return post<DownloadNotificationRequest, DownloadNotificationResponse>({
    path: `/api/v1/notificationPreferences`,
    body: {
      emailEnabled: true,
      frequency: 'Minute',
      triggerCount: 0,
      type: 'Download Ready',
      user: req.userId,
      what: 'userDownload',
      whatId: req.userDownloadId
    }
  })
}

export const deleteDownloadNotification = async (preferenceId: number) => {
  return remove({
    path: `/api/v1/notificationPreferences`,
    id: preferenceId
  })
}
